import React, { PureComponent } from 'react';
import styled from '@emotion/styled'

import { Grid } from 'style';

import HeroFrontText from './subcomponents/heroFrontText.component';

class HeroThoughts extends PureComponent {
  constructor(props) {
    super(props);
  }
  render() {
    const { text, words } = this.props;
    return (
      <HeroFrontWrapper id="HeroFront">
        <Grid.Container>
          <Grid.Row>
            <HeroFrontText {...{ text, words }} />
          </Grid.Row>
        </Grid.Container>
      </HeroFrontWrapper>
    );
  }
}

const HeroFrontWrapper = styled.div`
    width: 100%;
    min-height: 66vw;
    align-items: center;
    display: flex;
`;

export default HeroThoughts;
